module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAYAAADUryzEAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQ1JREFUeNqMk7ERgzAMRY0rSkpKl5QeIUwA6ehCNkgmCJuEdHS5bOARKCldUlJSRvIZziGyQXfCZ5/+syykiBHWNI2E5QSe2KMJXMF5v42NNkIUPayYMgV+d0GRI65hebJjdoX4dgXApoTl7UbM88ziOA5BctApDp+EunkcR9Z1nQF5zGg4eO0U68eGYWBt2/ogAp+NgCKUJ2YSgBQIkHsVC0AS7kufgmit/84RoI8AyrJkWZaRgH5PLKU0TphGwGdPjLd77MVtR5FZCCFCYmUaaWlNOzCrpWnKqqryiTH2vNSA2eHI3YJiG3taubdtPFHTiL/0Bn7BF2wLhm+GmMY7zhuYcCAa9uTv/gowAFTJZ7dOHBY9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/HomeView/sendDetails.png
// module id = 1019
// module chunks = 0